// Role switching utility for staff components

export const roleConfigs = {
  "Medical Professional": { 
    name: "Medical Professional", 
    component: "/medical-professional",
    localStorageKey: "medicalRoleData"
  },
  "Peer Educator": { 
    name: "Peer Educator", 
    component: "/peer-educator",
    localStorageKey: "peerRoleData"
  },
  "Content Curator": { 
    name: "Content Curator", 
    component: "/content-curator",
    localStorageKey: "contentRoleData"
  }
};

export const switchRole = (selectedRoleId, currentUserRole) => {
  if (selectedRoleId === currentUserRole) {
    return false; // No switch needed
  }

  const roleConfig = roleConfigs[selectedRoleId];
  if (!roleConfig) {
    console.error('Invalid role selected:', selectedRoleId);
    return false;
  }

  // Store the selected role and current timestamp for tracking
  const roleSwitchData = {
    selectedRole: selectedRoleId,
    switchedAt: new Date().toISOString(),
    previousRole: currentUserRole
  };

  // Store role switching data in localStorage
  localStorage.setItem('roleSwitchData', JSON.stringify(roleSwitchData));
  
  // Navigate to the selected role's component
  window.location.href = roleConfig.component;
  
  return true;
};

export const getRoleSwitchData = () => {
  const stored = localStorage.getItem('roleSwitchData');
  return stored ? JSON.parse(stored) : null;
};

export const clearRoleSwitchData = () => {
  localStorage.removeItem('roleSwitchData');
};

export const getCurrentRoleFromPath = (pathname) => {
  if (pathname.includes("/medical-professional")) {
    return "Medical Professional";
  } else if (pathname.includes("/peer-educator")) {
    return "Peer Educator";
  } else if (pathname.includes("/content-curator")) {
    return "Content Curator";
  }
  return null;
};

// Enhanced role switching with immediate current role update
export const switchRoleWithUpdate = (selectedRoleId, currentUserRole, setCurrentRoleCallback, navigate) => {
  if (selectedRoleId === currentUserRole) {
    return false; // No switch needed
  }

  const roleConfig = roleConfigs[selectedRoleId];
  if (!roleConfig) {
    console.error('Invalid role selected:', selectedRoleId);
    return false;
  }

  // Store the selected role and current timestamp for tracking
  const roleSwitchData = {
    selectedRole: selectedRoleId,
    switchedAt: new Date().toISOString(),
    previousRole: currentUserRole
  };

  // Store role switching data in localStorage
  localStorage.setItem('roleSwitchData', JSON.stringify(roleSwitchData));
  
  // Immediately update the current role state if callback provided
  if (setCurrentRoleCallback) {
    setCurrentRoleCallback(selectedRoleId);
  }
  
  // Navigate to the selected role's component using React Router if available, otherwise fallback to window.location
  if (navigate && typeof navigate === 'function') {
    navigate(roleConfig.component);
  } else {
    window.location.href = roleConfig.component;
  }
  
  return true;
};
